import React from 'react';
import { Ionicons } from '@expo/vector-icons';
import { useTheme } from '../theme/ThemeContext';

export type IconName =
  | 'checkbox' | 'checkbox-outline'
  | 'flag' | 'flag-outline'
  | 'eye' | 'eye-outline'
  | 'stats-chart' | 'stats-chart-outline'
  | 'settings' | 'settings-outline'
  | 'notifications' | 'notifications-outline' | 'notifications-off-outline'
  | 'cloud-offline-outline'
  | 'menu-outline'
  | 'search-outline'
  | 'close'
  | 'add'
  | 'create-outline'
  | 'trash-outline'
  | 'clipboard-outline'
  | 'copy-outline'
  | 'arrow-back'
  | 'log-out-outline'
  | 'ban-outline'
  | 'checkmark' | 'checkmark-circle'
  | 'warning'
  | 'information-circle-outline'
  | 'lock-closed'
  | 'key'
  | 'chevron-down' | 'chevron-up'
  | 'repeat-outline'
  | 'navigate-outline'
  | 'navigate';

/** Centralized icon size presets used across the app */
export const ICON_SIZES = {
  /** Tab bar icons (bottom navigation) */
  tabBar: 28,
  /** Header icons (hamburger menu, search) */
  header: 24,
  /** Drawer menu item icons */
  menu: 22,
  /** Drawer menu item icon container width (for alignment) */
  menuWidth: 24,
  /** Small inline indicators (dropdown arrows, team selection checks) */
  inline: 16,
  /** Dropdown chevron arrows */
  chevron: 14,
  /** Detail screen header action icons (clone, edit, delete) */
  action: 24,
  /** Empty state / hero icons */
  hero: 48,
  /** FAB icon */
  fab: 28,
} as const;

interface IconProps {
  name: IconName;
  size?: number;
  color?: string;
  style?: object;
}

export default function Icon({ name, size = ICON_SIZES.header, color, style }: IconProps) {
  const { colors } = useTheme();
  return (
    <Ionicons
      name={name}
      size={size}
      color={color ?? colors.textSecondary}
      style={style}
      accessible={false}
    />
  );
}
